import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  leftContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "37px",
    minHeight: "100%",
    backgroundColor: "#FFFFFF",
  },
  rightContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "31px 37px 8px",
    minHeight: "100%",
  },
}))

export default styles
